import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterOptions } from "../../pages/EmployeeOverview";

interface InitialState {
  departmentLists: string[];
  designationLists: string[];
  systemStatusLists: string[];
  employeeStatusLists: string[];
  search?: string;
  departmentOptions?: FilterOptions[];
  designationOptions?: FilterOptions[];
}

const initialState: InitialState = {
  departmentLists: [],
  designationLists: [],
  systemStatusLists: [],
  employeeStatusLists: [],
  search: "",
};

const employeeListSlice = createSlice({
  name: "employeeList",
  initialState,
  reducers: {
    setDepartmentLists: (state, action: PayloadAction<string[]>) => {
      state.departmentLists = action.payload;
    },
    setDesignationLists: (state, action: PayloadAction<string[]>) => {
      state.designationLists = action.payload;
    },
    setSystemStatusLists: (state, action: PayloadAction<string[]>) => {
      state.systemStatusLists = action.payload;
    },
    setEmployeeStatusLists: (state, action: PayloadAction<string[]>) => {
      state.employeeStatusLists = action.payload;
    },
    setEmployeeSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setDepartmentOptionsLists: (
      state,
      action: PayloadAction<FilterOptions[]>
    ) => {
      state.departmentOptions = action.payload;
    },
    setDesignationOptionsLists: (
      state,
      action: PayloadAction<FilterOptions[]>
    ) => {
      state.designationOptions = action.payload;
    },
    resetEmployeeListFilters: (state) => {
      state.departmentLists = [];
      state.designationLists = [];
      state.systemStatusLists = [];
      state.employeeStatusLists = [];
      state.search = "";
    },
  },
});

export const {
  setDepartmentLists,
  setDesignationLists,
  setSystemStatusLists,
  setEmployeeStatusLists,
  setEmployeeSearch,
  setDepartmentOptionsLists,
  setDesignationOptionsLists,
  resetEmployeeListFilters,
} = employeeListSlice.actions;
export default employeeListSlice.reducer;
